export const PAGE_PATH = '/settings';
